import { Box, Group, Image, Stack } from "@mantine/core";

import { Button, NumberInput, Text } from "components";
import { TargetOptionResponse } from "types";

import classes from "./TargetsPage.module.css";

type TargetValues = Record<string, number | "">;

interface TargetSectionProps {
  getTargetHint: (group: string) => string;
  getTargetLabel: (option: TargetOptionResponse) => string;
  getTargetLogo: (option: TargetOptionResponse) => string | undefined;
  isDisabled: boolean;
  isSaving: boolean;
  inputLabel: string;
  inputPlaceholder: string;
  onSave: () => void;
  onTargetChange: (type: string, value: string | number) => void;
  options: TargetOptionResponse[];
  plainInput: boolean;
  saveLabel: string;
  title: string;
  values: TargetValues;
}

const TargetSection = ({
  getTargetHint,
  getTargetLabel,
  getTargetLogo,
  isDisabled,
  isSaving,
  inputLabel,
  inputPlaceholder,
  onSave,
  onTargetChange,
  options,
  plainInput,
  saveLabel,
  title,
  values,
}: TargetSectionProps) => (
  <section className={classes.panel}>
    <Text className={classes.sectionTitle}>{title}</Text>

    <Stack gap="md" mt="md">
      {options.map((option) => {
        const logo = getTargetLogo(option);

        return (
          <div key={option.type} className={classes.targetCard}>
            <div className={classes.targetMeta}>
              {logo ? (
                <div className={classes.logoWrap}>
                  <Image src={logo} alt={getTargetLabel(option)} className={classes.logo} />
                </div>
              ) : null}

              <Box className={classes.targetIdentity}>
                <Text className={classes.targetName}>{getTargetLabel(option)}</Text>
                <Text className={classes.targetHint}>{getTargetHint(option.group)}</Text>
              </Box>
            </div>

            <div className={classes.inputWrap}>
              <NumberInput
                label={inputLabel}
                placeholder={inputPlaceholder}
                value={values[option.type] ?? ""}
                onChange={(value) => onTargetChange(option.type, value)}
                plain={plainInput}
                required
                min={0}
              />
            </div>
          </div>
        );
      })}
    </Stack>

    <Group justify="flex-end" align="center" mt="lg" className={classes.footer}>
      <Button
        onClick={onSave}
        disabled={isDisabled}
        loading={isSaving}
        radius="md"
        size="md"
        className={classes.saveButton}
      >
        {saveLabel}
      </Button>
    </Group>
  </section>
);

export default TargetSection;
